import React from 'react'
import { Element } from 'react-scroll'
import SectionTitle2 from '../../sectionTitle/SectionTitle2'

const AISolutions = () => {
  return (
    <>
      <Element
        name="AISolutions"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Key Focus Areas"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center section-description">Our platform brings low-latency, embedded intelligence to ships, ports, offshore structures, and underwater systems-empowering smarter, greener maritime operations even in disconnected environments.</p>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/gear.svg`} alt="gear" />
                </div>
                <h5 className="mt-3 mb-3">Dynamic Vessel Optimization</h5>
                <p className="mb-0">Real-time route planning, speed regulation, and energy optimization using AI models based on ocean and weather data.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/eye.svg`} alt="eye" />
                </div>
                <h5 className="mt-3 mb-3">Wave Energy Converter (WEC) Optimization</h5>
                <p className="mb-0">AI-enhanced positioning, control, and fault detection for wave energy farms and offshore power systems.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/no-axis-columns-increasing.svg`} alt="no-axis-columns-increasing" />
                </div>
                <h5 className="mt-3 mb-3">Emission & Fuel Monitoring</h5>
                <p className="mb-0">Edge-based tracking of fuel usage and emissions to meet compliance standards and reduce environmental impact.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/spark.svg`} alt="spark" />
                </div>
                <h5 className="mt-3 mb-3">Predictive Maintenance for Marine Equipment</h5>
                <p className="mb-0">Early detection of anomalies in propulsion, hull integrity, and critical systems using sensor data.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/chart.svg`} alt="chart" />
                </div>
                <h5 className="mt-3 mb-3">Port & Coastal Operations Intelligence</h5>
                <p className="mb-0">Monitoring of tides, currents, vessel docking conditions, and environmental impact metrics via AI at the edge.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/shield-check.svg`} alt="shield-check" />
                </div>
                <h5 className="mt-3 mb-3">Aquaculture & Marine Habitat Monitoring</h5>
                <p className="mb-0">Real-time environmental sensing and automated insights to optimize fish health, feeding efficiency, and marine biodiversity protection.</p>
              </div>  
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default AISolutions;